export default { 'EventStatus.completed': { en: 'Completed', fr: 'Terminé' } };
